export const REQUIRED = 'Este campo é obrigatório!';
export const EMAIL_INVALID = 'Formato de e-mail inválido!';
export const MAX = (n) => `O campo deve ter no máximo ${n} caracteres!`;
export const MIN = (n) => `O campo deve ter no mínimo ${n} caracteres!`;
